/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add service description
 */

export const addServiceDescriptionBodyTextRegExp = new RegExp(".*\\S.*");

export const AddServiceDescriptionBody = zod.object({
  language: zod.enum(["ES", "EN", "FR"]).describe("Supported business language."),
  text: zod.string().min(1).regex(addServiceDescriptionBodyTextRegExp),
});

export const AddServiceDescriptionResponse = zod
  .enum(["ES", "EN", "FR"])
  .describe("Supported business language.");

/**
 * @summary Edit service description
 */

export const editServiceDescriptionBodyTextRegExp = new RegExp(".*\\S.*");

export const EditServiceDescriptionBody = zod.object({
  text: zod.string().min(1).regex(editServiceDescriptionBodyTextRegExp),
});

export const EditServiceDescriptionResponse = zod.void();
